const FileBaseRoute = 'files';

export function getFileUrl(id) {
  return { path: `${FileBaseRoute}/${id}` };
}

export function searchFiles(search) {
  return { path: `${FileBaseRoute}${search}` };
}

export function createFileUrl(body) {
  return {
    path: FileBaseRoute,
    method: 'POST',
    body: JSON.stringify(body),
  };
}

export function permanentlyDeleteFile(id) {
  return {
    path: `${FileBaseRoute}/${id}/permanent`,
    method: 'DELETE',
  };
}

export function deleteFile(id) {
  return {
    path: `${FileBaseRoute}/${id}`,
    method: 'DELETE',
  };
}

export function restoreDeletedFile(id, file) {
  return {
    path: `${FileBaseRoute}/${id}/restore`,
    method: 'PUT',
    body: JSON.stringify(file),
  };
}
